import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { AccountProvider } from './contexts/AccountContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CartDrawer } from './components/CartDrawer';
import { AccountDialog } from './components/AccountDialog';
import { Home } from './pages/Home';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rit2b37fdqpd">
      <CartProvider data-id="element-1" data-mp="2mluairb8hvuc">
        <AccountProvider data-id="element-2" data-mp="2mmcc83go129n">
          <div className="min-h-screen w-full bg-bone font-sans antialiased" data-id="element-3" data-mp="2mn5aeg1k6jg6">
            <Header data-id="element-4" data-mp="31ayqs2ygxpzt" />
            <main data-id="element-5" data-mp="31bi7xhgaoacs">
              <Routes data-id="element-6" data-mp="31c1l6kv02akh">
                <Route path="/" element={<Home data-id="element-8" data-mp="2wjgu3r3habkn" />} data-id="element-7" data-mp="2wk0b95lb0vxm" />
              </Routes>
            </main>
            <Footer data-id="element-9" data-mp="2wi5qbra193tj" />
            <CartDrawer data-id="element-10" data-mp="28tw62tsgwo4i" />
            <AccountDialog data-id="element-11" data-mp="28te4dhn1dhp7" />
          </div>
        </AccountProvider>
      </CartProvider>
    </BrowserRouter>;
}